import script from "./ClientImages.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientImages.vue?vue&type=script&setup=true&lang=js"

import "./ClientImages.vue?vue&type=style&index=0&id=74576c1c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74576c1c"]])

export default __exports__